import DraggableGear from "./components/DraggableGear";

export default function Home() {
  return (
    <main className="h-screen w-full bg-background-50 text-foreground-950 font-body overflow-hidden">
      {/* Hero — full viewport */}
      <section className="relative w-full h-full px-8 md:px-14 py-8 md:py-12">
        {/* Title bar — upper left */}
        <div className="absolute top-8 md:top-12 left-8 md:left-14 z-20 max-w-[760px]">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
              <i className="ri-settings-3-fill text-background-50 text-lg" />
            </div>
            <span className="font-heading text-2xl font-semibold tracking-tight">
              Mechanica
            </span>
          </div>

          <h1 className="mt-8 font-heading font-light leading-[0.92] tracking-[-0.035em] text-foreground-950 text-[60px] md:text-[88px] lg:text-[112px] xl:text-[128px]">
            <span className="block">Made to</span>
            <span className="block italic font-normal text-primary-500">
              turn, not spin.
            </span>
          </h1>

          <p className="mt-6 max-w-[440px] text-base md:text-[17px] leading-relaxed text-foreground-700">
            A studio of meshing parts. Drag the red gear and watch the
            mechanism come alive — every tooth, every ratio, exact.
          </p>
        </div>

        {/* Decorative cluster — lower left */}
        <div className="absolute bottom-8 md:bottom-12 left-8 md:left-14 z-20 flex items-end gap-8">
          {/* Vertical index marker */}
          <div className="flex flex-col items-start gap-3">
            <div className="w-px h-16 bg-foreground-300" />
            <div className="flex items-baseline gap-2 font-heading">
              <span className="text-[10px] tracking-[0.3em] text-foreground-500 uppercase">
                Index
              </span>
              <span className="text-[10px] tracking-[0.3em] text-foreground-400">
                /
              </span>
              <span className="text-[10px] tracking-[0.3em] text-primary-500 uppercase">
                01 — Genesis
              </span>
            </div>
          </div>

          {/* Technical readout block */}
          <div className="hidden md:flex flex-col gap-1.5 pl-8 border-l border-foreground-200">
            <div className="flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-foreground-500">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse" />
              Live · Drag enabled
            </div>
            <div className="font-heading text-[11px] tracking-[0.18em] text-foreground-600 uppercase">
              Teeth 24 · Mod 1.5 · RPM 0.0
            </div>
            <div className="font-heading text-[11px] tracking-[0.18em] text-foreground-400 uppercase">
              N 51°30′ · W 0°07′ · Studio
            </div>
          </div>

          {/* Decorative geometric stack */}
          <div className="hidden lg:flex items-end gap-2 ml-2">
            <div className="w-2 h-8 bg-foreground-900" />
            <div className="w-2 h-12 bg-primary-500" />
            <div className="w-2 h-6 bg-foreground-300" />
            <div className="w-2 h-10 border border-foreground-900" />
            <div className="flex flex-col gap-1 ml-1">
              <div className="w-6 h-px bg-foreground-400" />
              <div className="w-4 h-px bg-foreground-400" />
              <div className="w-5 h-px bg-foreground-400" />
            </div>
          </div>

          {/* Crosshair / target */}
          <div className="hidden xl:flex relative w-12 h-12 ml-2">
            <div className="absolute inset-0 rounded-full border border-foreground-300" />
            <div className="absolute top-1/2 left-0 right-0 h-px bg-foreground-300" />
            <div className="absolute left-1/2 top-0 bottom-0 w-px bg-foreground-300" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-full bg-primary-500" />
          </div>
        </div>

        {/* Gear stage — pushed to the right */}
        <div className="relative w-full h-full flex items-center justify-end pr-0 lg:pr-[4%] xl:pr-[8%]">
          {/* concentric guide rings — follow the gear to the right */}
          <div className="absolute top-1/2 -translate-y-1/2 right-0 lg:right-[4%] xl:right-[8%] translate-x-1/2 pointer-events-none">
            <div className="w-[760px] h-[760px] rounded-full border border-dashed border-foreground-300/60" />
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 right-0 lg:right-[4%] xl:right-[8%] translate-x-1/2 pointer-events-none">
            <div className="w-[900px] h-[900px] rounded-full border border-foreground-200/70" />
          </div>
          <div className="absolute top-1/2 -translate-y-1/2 right-0 lg:right-[4%] xl:right-[8%] translate-x-1/2 pointer-events-none">
            <div className="w-[1040px] h-[1040px] rounded-full border border-dashed border-foreground-200/60" />
          </div>

          <div className="translate-x-[20%] lg:translate-x-[28%] xl:translate-x-[32%]">
            <DraggableGear size={480} />
          </div>
        </div>
      </section>
    </main>
  );
}